/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit CheckedOut/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaIconDone from 'DesignSystem/Svgs/TysiaIconDone/index'



/** @type {import('Simple/types.js').View} */
export default function CheckedOut({
  children,
  viewPath = "/DesignSystem/TimelineEvent/Appointment/Indicator/Past/Icon/CheckedOut"
  
}) {
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
  return (<React.Fragment
>
<TysiaIconDone
  viewPath={`${viewPath}/TysiaIconDone`}
 fill={dtColorsWhite}
 width={16}
 height={16}
/>
{children}
</React.Fragment>)
}